import { create } from 'zustand';
import { enqueueSnackbar } from 'notistack';
import axiosInstance from '../auth/axiosInstance';
import { useGetRequests } from './useGetRequests';

export const useRequestActions = create((set) => ({
  isRequestDeleted: false,
  isStatusChanged: false,
  dataErrorMessage: '',

  setRequestStatus: (id, actionValue) => {
    set((state) => ({
      ...state,
      isStatusChanged: false,
      dataErrorMessage: '',
    }));

    axiosInstance
      .patch(
        `${process.env.REACT_APP_API_BASE_URL}/requests/${id}/admin/${actionValue}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('sessionToken')}`,
          },
        }
      )
      .then(() => {
        set((state) => ({
          ...state,
          isStatusChanged: true,
          dataErrorMessage: '',
        }));
        // eslint-disable-next-line no-undef
        enqueueSnackbar(!dataErrorMessage && 'Status updated successfully', {
          variant: 'success',
        });
        // useGetRequests.getState().getRequests();
      })
      .catch((error) => {
        set((state) => ({
          ...state,
          isStatusChanged: false,
          dataErrorMessage: error?.response?.data.message,
        }));
        enqueueSnackbar(error?.response?.data.message, { variant: 'error' });
      });
  },

  deleteRequest: (id) => {
    set((state) => ({
      ...state,
      isRequestDeleted: false,
    }));

    axiosInstance
      .delete(`${process.env.REACT_APP_API_BASE_URL}/requests/admin/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('sessionToken')}`,
        },
      })
      .then(() => {
        set((state) => ({
          ...state,
          isStatusChanged: true,
        }));
      })
      .catch((error) => {
        console.error(error.message);
        set((state) => ({
          ...state,
          isStatusChanged: false,
          dataErrorMessage: error.message,
        }));
      });
  },
}));
